import { Api } from '../AApi'

export const API_BASEMAP = new Api(
  {
    url: 'base-maps',
    isConvertFormData: true,
    // only: ['store', 'show', 'update', 'destroy', 'index'],
  },
  {
    setDefault: {
      async request(id) {
        return this.sdk
          .request({
            method: 'put',
            url: `set-default/${id}`,
          })
          .then((res) => res.data.data)
      },
    },
  }
)
